// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"a5e90e83","681":"84bc07ea"}[chunkId] + ".css";
};